import React, { Component } from 'react';
import TextTruncate from 'react-text-truncate';
import { jsx, css } from '@emotion/core';
import Slider from 'react-slick';
import SlickArrowCircle from '../../../shared/SlickArrow/SlickArrowCirclePrimary';
import SlickArrow from '../../../shared/SlickArrow/SlickArrow';
import Arrow from '../../../shared/Icons/Arrow';

import { primary_s5_l90, primary_light } from '../../../shared/lib/colors';

import Link from '../../../shared/Link/Link';
import Button from '../../../shared/Button/Button';

import './Magazine.scss';
import { FaChevronRight } from 'react-icons/fa';
import { clean } from 'mocha/lib/utils';
import Markdown from 'react-remarkable';
import SlickArrowCircleSecondary from '../../../shared/SlickArrow/SlickArrowCircleSecondary';
import SlickArrowCirclePrimary from '../../../shared/SlickArrow/SlickArrowCirclePrimary';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

class Magazine extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPost: {
        id: null,
        imgUrl: null,
      },
    };
  }

  componentWillReceiveProps() {
    this.props.posts[0] &&
      this.setState({
        selectedPost: {
          id: this.props.posts[0].id,
          imgUrl: this.props.posts[0].featuredImageUrl,
        },
      });
  }

  setSelectedPost = post => event => {
    this.setState({
      selectedPost: { id: post.id, imgUrl: post.featuredImageUrl },
    });
  };

  render() {
    const { posts, primaryColor, secondaryColor } = this.props;
    const { selectedPost } = this.state;

    const magazineStyle = css`
      &.version-2 {
        .magazine-box {
          display: block;
          padding-bottom: 20px;

          .articles-list {
            display: flex;
            flex-direction: column;
            align-items: center;

            & .magazine-headers {
              display: none;
            }

            .slick-slider {
              width: 100%;
              justify-content: center;
              .slick-list > .slick-track {
                .slick-slide {
                  margin-right: 0px;
                  & div > a > .article-card {
                    margin-top: 26px;
                    margin-left: 60px;
                    margin-right: 60px;

                    @media screen and (max-width: 428px) {
                      margin-left: unset;
                      margin-right: 8px;
                      margin-top: 8px;
                    }

                    @media screen and (max-width: 992px) {
                      margin-left: 13px;
                      margin-right: 13px;
                    }

                    .article-image {
                      img {
                        margin-bottom: 30px;
                        margin-left: 3px;

                        @media screen and (max-width: 428px) {
                          margin-bottom: 24px;
                          margin-left: 0px;
                        }

                        @media screen and (min-width: 992px) {
                          height: 298px;
                        }
                      }
                    }
                    .article-text {
                      h6 {
                        font-size: 21px;
                        @media screen and (min-width: 1700px) {
                          font-size: 26px;
                        }
                        @media screen and (max-width: 768px) {
                          font-size: 16px;
                        }
                      }
                      p {
                        display: none !important;
                      }
                    }
                  }
                }
              }

              .slick-prev {
                top: 34%;
                left: 3%;
                @media screen and (min-width: 992px) {
                  left: 2%;
                }
              }
              .slick-next {
                top: 34%;
                right: 0%;
                @media screen and (min-width: 992px) {
                  right: 3.5%;
                }
              }
            }
          }
        }
      }
    `;

    const readMoreButton = css`
      &.btn {
        margin: 0;
        background-color: ${secondaryColor};
        border-color: ${secondaryColor};
        height: 38px;
        width: 112px;
        height: 12%;
        width: 45%;
        position: absolute;
        left: 28%;
        top: 34%;
        opacity: 1;
      }
      @media screen and (min-width: 1200px) {
        min-width: 88px;
      }

      span {
        color: #ffff;
        font-size: 14px;
        line-height: 16.44px;
      }
    `;

    const dotsStyle = css`
      .slick-dots {
        display: flex !important;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: -55px;

        @media screen and (max-width: 992px) {
          bottom: -48px;
        }

        @media screen and (max-width: 428px) {
          display: none !important;
        }

        & li > .dot {
          height: 8px;
          width: 8px;
          background-color: #f2f2f2;
          border-radius: 50%;

          &:hover,
          &.active {
            background-color: ${secondaryColor};
          }
          &::before {
            color: none;
            content: none;
            opacity: 0;
          }
        }

        & > .slick-active {
          background-color: transparent;

          & .dot {
            background-color: ${secondaryColor};
          }
        }
      }
    `;

    const latestThreePosts = posts.slice(0, 3);
    const regex = /([^\d\w-]+)/g;

    const cleanUrl = string => {
      if (!!string) {
        return (string || '').replace(regex, '-');
      }
    };

    const shortenExcerpt = excerpt => {
      const trimmedString = excerpt.substr(
        0,
        Math.min(excerpt.length, excerpt.lastIndexOf(' '))
      );
      return trimmedString;
    };

    function capitalizeString(string) {
      let lowercaseString = string.toLowerCase();
      return lowercaseString.charAt(0).toUpperCase() + lowercaseString.slice(1);
    }

    const settings = {
      arrows: true,
      prevArrow:
        this.props.sliderCircleArrowsMagazine === 1 &&
        this.props.blogNewsletterVersion === 1 ? (
          <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
        ) : this.props.sliderCircleArrowsMagazine === 1 &&
          this.props.blogNewsletterVersion === 2 ? (
          <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
        ) : this.props.sliderCircleArrowsMagazine === 0 ? (
          <SlickArrow />
        ) : this.props.sliderCircleArrowsMagazine === 1 &&
          this.props.blogNewsletterVersion === 3 ? (
          <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
        ) : null,
      nextArrow:
        this.props.sliderCircleArrowsMagazine === 1 &&
        this.props.blogNewsletterVersion === 1 ? (
          <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
        ) : this.props.sliderCircleArrowsMagazine === 1 &&
          this.props.blogNewsletterVersion === 2 ? (
          <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
        ) : this.props.sliderCircleArrowsMagazine === 0 ? (
          <SlickArrow />
        ) : this.props.sliderCircleArrowsMagazine === 1 &&
          this.props.blogNewsletterVersion === 3 ? (
          <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
        ) : null,
      dots: this.props.navigationDotsMagazine === 1 ? true : false,
      customPaging: function(i) {
        return <button className="dot">{/* {i + 1} */}</button>;
      },
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 9000,
      pauseOnHover: false,
      speed: 600,
      slidesToShow: this.props.blogNewsletterVersion !== 2 ? 2 : 1,
      slidesToScroll: this.props.blogNewsletterVersion !== 2 ? 2 : 1,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: this.props.blogNewsletterVersion !== 2 ? 2 : 1,
            slidesToScroll: this.props.blogNewsletterVersion !== 2 ? 2 : 1,
          },
        },
        { breakpoint: 567, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    };

    function trimParagraphStyle(title) {
      const paragraphStyle =
        title.length > 31
          ? {
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }
          : title.length > 50
          ? {
              display: '-webkit-box',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }
          : {};
      return paragraphStyle;
    }

    return (
      <div
        className={`magazine version-${this.props.blogNewsletterVersion}`}
        css={magazineStyle}
      >
        <div className="magazine-box">
          <div className="articles-list">
            <div className="magazine-headers">
              <p>Blog</p>
              <Link to="/blog">
                <p style={{ color: primaryColor }}>Visualizza tutti</p>
                <Arrow />
              </Link>
            </div>
            <Slider {...settings} css={dotsStyle}>
              {posts.map(post => {
                const title = post.title;
                const correctStyle = trimParagraphStyle(title);

                return (
                  <Link
                    to={`/blog/${post.id}-${cleanUrl(title)}`}
                    className="title-link"
                  >
                    <article className="article-card">
                      <header className="article-text">
                        <div className="article-image">
                          <ImageDispatcher
                            src={post.featuredImageUrl}
                            alt={title}
                          />
                          {this.props.blogNewsletterVersion === 2 ? (
                            <Button
                              type="button"
                              className="btn btn-primary btn-thick"
                              disabled={
                                !this.state.email || !this.state.privacy
                              }
                              style={{
                                backgroundColor: secondaryColor,
                                cursor: 'pointer',
                              }}
                              css={readMoreButton}
                            >
                              <span>Leggi di più</span>
                            </Button>
                          ) : null}
                        </div>

                        <h3 style={{ color: '#222' }}>
                          {capitalizeString(title)}
                        </h3>
                      </header>

                      <p className="article-excerpt" style={correctStyle}>
                        {shortenExcerpt(post.excerpt)}
                      </p>
                    </article>
                  </Link>
                );
              })}
            </Slider>
          </div>
        </div>
      </div>
    );
  }
}

export default Magazine;
